import Repository from '../ai_chat_axios'

export default {
  getCurrentUer() {
    return Repository.get(`/auth/me`)
  },
  exchangeToken(token) {
    return Repository.post(
      '/auth/exchange-token',
      null,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )
  },
  sendMessage(payload) {
    return Repository.post('/chat/message/sync', payload)
  },
  fetchSessionList() {
    return Repository.get('/sessions/?limit=50')
  },
  getSessionMessages(session_id) {
    return Repository.get(`sessions/${session_id}`)
  }
};
